module.exports = __webpack_public_path__ + "static/img/xj2.7cef3109.svg";